import React, { useState, useEffect } from "react";
import Etape1 from "../components/Etape1";
import Etape2 from "../components/Etape2";
import Etape3 from "../components/Etape3";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import UsersList from "../components/UsersList";
import { apiFetch } from '../utils/apiClient';
import { io } from "socket.io-client";
import { XCircleIcon } from "@heroicons/react/solid";
import { Trash2,FileText } from "lucide-react";
// Connexion au serveur Socket.io
const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`);


function Formulaire({ user, checkGroupRecMensuelle, checkGroupAdmin,enabled }) {

  // ⚙️ États pour gérer les erreurs et messages du formulaire
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [couleur, setcouleur] = useState("");

  // Informations sur l'utilisateur connecté
  const [emailUser, setEmailUser] = useState("");
  const [nomUser, setNomUser] = useState("");
  const [idUser, setIdUser] = useState("");

  // États pour réaffectation
  const [showReassignPopup, setShowReassignPopup] = useState(false);
  const [errorReassign, setErrorReassign] = useState("");


  // Navigation
  const navigate = useNavigate();

  // Gestion des étapes du formulaire
  const [currentStepComponent, setCurrentStepComponent] = useState("Etape1");



  // États pour les données liées aux dépenses
  const [maxAmounts, setMaxAmounts] = useState({});


  // États pour gérer la récupération d’un formulaire sélectionné
  const [selectedForm, setSelectedForm] = useState(null);
  const [formId, setFormId] = useState(null);
  // const [page, setPage] = useState(() => sessionStorage.getItem("page") || null);
  const params = new URLSearchParams(window.location.search);

  const numeroFormulaire = params.get("numeroFormulaire");
  // const userId = params.get("userId");
  const page = params.get("page");

  // const [isLoading, setIsLoading] = useState(page?true:false);
  const [isLoading, setIsLoading] = useState(!!page);
  const [showAccessDenied, setShowAccessDenied] = useState(false);

  const [loadingAction, setLoadingAction] = useState(null);

  // ✅ useEffect pour récupérer le formulaire depuis sessionStorage et l’API
  useEffect(() => {
  let isMounted = true;

  const fetchForm = async () => {
    try {
      // ✅ guard clause (BEST PRACTICE)
      if (!numeroFormulaire || !user.id || !page) {
        console.warn("Missing form identifiers");
        navigate("/formulaire");
        return;
      }
      setIsLoading(true);
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/selectedForm?numeroFormulaire=${numeroFormulaire}&userIdTrait=${user.id}&page=${page}`
      );

      if (!response.ok) {
        if (response.status === 403) {
          throw new Error("NOT_AUTHORIZED");
        }
        if (response.status === 400) {
          throw new Error("BAD_REQUEST");
        }
        throw new Error("FAILED_FETCH");
      }

      const data = await response.json();

      if (!isMounted) return;

      setSelectedForm(data);
      setFormId(data._id);

    } catch (error) {
      if (error.message === "NOT_AUTHORIZED") {
        setShowAccessDenied(true);
      } else {
        console.error("Error fetching form data:", error);
      }

    } finally {
      if (!isMounted) return;

      setTimeout(() => {
        if (!isMounted) return;
        setIsLoading(false);
      }, 400);
    }
  };

  fetchForm();

  return () => {
    isMounted = false;
  };
}, [user, numeroFormulaire, page]);

const [drafts, setDrafts] = useState([]);
const [showDraftPopup, setShowDraftPopup] = useState(false);

useEffect(() => {
  let isMounted = true;

  const fetchDrafts = async () => {
    try {
      // ✅ condition clé
      if (numeroFormulaire || page || !user.id) return;

      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/demandes-brouillon?userId=${user.id}`
      );

      if (!response.ok) throw new Error("FAILED_FETCH_DRAFTS");

      const data = await response.json();

      if (!isMounted) return;

      if (data.length > 0) {
        setDrafts(data);
        setShowDraftPopup(true); // 👈 déclenche popup
      }

    } catch (error) {
      console.error("Error fetching drafts:", error);
    }
  };

  fetchDrafts();

  return () => {
    isMounted = false;
  };
}, [user, numeroFormulaire, page]);

const handleDeleteDraft = async (id) => {
  try {
    const res = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/modify-etatdemande/${id}`,
        {
          method: "PUT", // or 'POST' depending on your backend setup
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            etatDemande: "Supprimé",
            nomFormulaire: "Réclamation mensuelle de dépenses",
            userId: user.id,
            nom: user.displayName,
            email: user.mail,
            commentaire: "",
          }), // Update this value as needed
        }
      );
    if (!res.ok) throw new Error("DELETE_FAILED");

    // 🔥 update UI sans reload
    setDrafts((prev) => prev.filter((d) => d._id !== id));

  } catch (error) {
    console.error("Error deleting draft:", error);
  }
};

  // useEffect(() => {
  //   console.log(1)
  //   const numeroFormulaire = sessionStorage.getItem("numeroFormulaire");
  //   const userId = sessionStorage.getItem("userId");

  //   if (numeroFormulaire && userId) {
  //     const fetchForm = async () => {
  //       try {
  //         const response = await apiFetch(
  //           `${process.env.REACT_APP_API_BASE_URL}/selectedForm?numeroFormulaire=${numeroFormulaire}&userId=${userId}`
  //         );
  //         if (!response.ok) throw new Error("Failed to fetch form data");
  //         const data = await response.json();
  //         setSelectedForm(data);
  //         setFormId(data._id)

  //       } catch (error) {
  //         console.error("Error fetching form data:", error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     };

  //     fetchForm();
  //     console.log(2)
  //   } else {
  //     console.warn("Missing form identifiers in sessionStorage");
  //     setIsLoading(false);
  //   }
  // }, []);

  // // ⚙️ Nettoyage des items de sessionStorage après chargement
  // useEffect(() => {
  //   if (!isLoading) {
  //     sessionStorage.removeItem("numeroFormulaire");
  //     sessionStorage.removeItem("userId");
  //     sessionStorage.removeItem("page");
  //   }
  // }, [isLoading]);


  // ✅ Fonction pour générer un numéro de formulaire unique
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-Exp-${yy}${mm}${dd}${randomNumber}`;
  };


  // ✅ Fonction pour convertir une chaîne Base64 en File (pour les fichiers uploadés)
  const base64ToFile = (base64, filename, mimeType, _id = null) => {
    try {
      // Vérifier si la chaîne est bien formée
      if (!base64.includes("base64,")) {
        throw new Error("Base64 string is not correctly formatted");
      }

      // Supprimer les espaces et sauts de ligne qui peuvent casser atob()
      const base64String = base64.split("base64,")[1]?.replace(/\s/g, "");

      if (!base64String) {
        throw new Error("Invalid base64 string");
      }

      // Vérifier si la chaîne Base64 est valide avant de la décoder
      if (!/^[A-Za-z0-9+/=]+$/.test(base64String)) {
        throw new Error("Base64 contains invalid characters");
      }

      // Décoder en bytes
      const byteCharacters = atob(base64String);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Uint8Array(
          [...slice].map((char) => char.charCodeAt(0))
        );
        byteArrays.push(byteNumbers);
      }

      // Créer le fichier
      const blob = new Blob(byteArrays, { type: mimeType });

      // return new File([blob], filename, { type: mimeType });
      const file = new File([blob], filename, { type: mimeType });

      // Ajout de l'_id manuellement à l'objet file
      if (_id) file._id = _id;

      return file;

    } catch (error) {
      console.error(
        "Erreur lors de la conversion base64 en fichier:",
        error.message
      );
      return null; // Retourne null si la conversion échoue
    }
  };

  // ⚙️ Initialisation des données du formulaire
  const initialFormData = {
    numeroFormulaire:
      selectedForm?.numeroFormulaire || generateNumeroFormulaire(),
    dateSoumission: new Date().toISOString().split("T")[0],
    soumisAutreMembre: selectedForm?.soumisAutreMembre || "non",
    verificationDelegue: selectedForm?.verificationDelegue || "non",
    commentaireRaisonSoumission:
      selectedForm?.commentaireRaisonSoumission || "",
    posteOccupe: selectedForm?.posteOccupe || "",
    LieuTravail: selectedForm?.LieuTravail || "",
    periodReclamation: selectedForm?.periodReclamation
      ? selectedForm.periodReclamation.slice(0, 7) // Extract YYYY-MM if it contains YYYY-MM-DD
      : "",
    periodDepasseTroisMois: selectedForm?.periodDepasseTroisMois || "non",
    justificationOutrepasse: selectedForm?.justificationOutrepasse || "",
    managerInfo: selectedForm?.managerInfo || {
      nom: "",
      email: "",
      userId: "",
      matricule: "",
      etatDamande: "",
    },
    soumisParAutreMembre: selectedForm?.soumisParAutreMembre || {
    },
    delegueInfo: selectedForm?.delegueInfo || {},
    achatsCarteCréditProfessionnelle:
      selectedForm?.achatsCarteCréditProfessionnelle || "non",
    depensesEtrReclamer: selectedForm?.depensesEtrReclamer || "non",
    depensesActiviteExterne: selectedForm?.depensesActiviteExterne || "non",
    reclameBoissonAlcoolise: selectedForm?.reclameBoissonAlcoolise || "non",
    etatDemande: selectedForm?.etatDemande || "",
    funds: selectedForm?.funds || "",
    centreCout: selectedForm?.centreCout || "",
    ordre: selectedForm?.ordre || null,
    traitant: selectedForm?.traitant || [],
    depenses: [],
    visaConseil: {},
    ETRFiles: [],
    formation: {},
    montantkilometrage: selectedForm?.montantkilometrage || 0,
    montantVisaConseil: selectedForm?.montantVisaConseil || 0,
    montantAutresDepenses: selectedForm?.montantAutresDepenses || 0,
    montantNet: selectedForm?.montantNet || 0,
    listeDesNotes: selectedForm?.listeDesNotes || [],
  };

  const [formData, setFormData] = useState(initialFormData);

  // ✅ useEffect pour pré-remplir le formulaire selon l’utilisateur connecté ou le formulaire sélectionné
  useEffect(() => {
    // Si user existe et pas de formulaire sélectionné → remplir avec données utilisateur
    if (user && !selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        matricule: user.employeeId,
        posteOccupe: user.jobTitle || "",
        LieuTravail: user.officeLocation || "",
      }));
    }
    // Si formulaire sélectionné → pré-remplir tout le formulaire et définir read-only selon étatDemande
    if (selectedForm) {
      // Conditions complexes pour rendre le formulaire en lecture seule
      if (
        (selectedForm.formulaire === "Réclamation mensuelle de dépenses" &&
          selectedForm.etatDemande !== "Brouillon" && page === "Mes taches" &&
          (
            // Afficher si soumisParAutreMembre n'existe pas
            !selectedForm.soumisParAutreMembre ||

            // OU : nom vide ET etatDemande vide
            (selectedForm.soumisParAutreMembre.nom === "" &&
              selectedForm.soumisParAutreMembre.etatDemande === "") ||

            // OU : nom présent ET etatDemande approuvé
            (selectedForm.soumisParAutreMembre.nom !== "" &&
              selectedForm.soumisParAutreMembre.etatDemande === "Approuvé")
          )
        )
        ||
        (selectedForm.formulaire === "Réclamation mensuelle de dépenses" &&
          (selectedForm.etatDemande === "En traitement" && selectedForm.etatDemande === "Approuvé")
          && page !== "Mes taches") ||
        (selectedForm.formulaire === "Réclamation mensuelle de dépenses" &&
          (selectedForm.etatDemande !== "Brouillon" && selectedForm.etatDemande !== "Rejeté")
          && page !== "Mes taches"
        )
      ) {
        setIsReadOnly(true);
      }

      // Mise à jour complète du formData avec le formulaire sélectionné
      setFormData((prevData) => ({
        ...prevData,
        nom: selectedForm.nom,
        userId: selectedForm.userId,
        courriel: selectedForm.courriel,
        matricule: selectedForm.matricule,
        numeroFormulaire: selectedForm.numeroFormulaire,
        dateSoumission:
          selectedForm.etatDemande === "Brouillon"
            ? new Date().toISOString().split("T")[0]
            : selectedForm.dateSoumission ||
            prevData.dateSoumission,

        soumisAutreMembre: selectedForm.soumisAutreMembre || "non",
        verificationDelegue: selectedForm.verificationDelegue || "non",
        commentaireRaisonSoumission: selectedForm.commentaireRaisonSoumission || "",
        posteOccupe: selectedForm.posteOccupe || "",
        LieuTravail: selectedForm.LieuTravail || "",
        periodReclamation: selectedForm.periodReclamation
          ? selectedForm.periodReclamation.slice(0, 7)
          : "",
        periodDepasseTroisMois: selectedForm.periodDepasseTroisMois || "non",
        justificationOutrepasse: selectedForm.justificationOutrepasse || "",
        managerInfo: selectedForm.managerInfo || {
          nom: "",
          email: "",
          userId: "",
          matricule: "",
          etatDemande: "",
        },
        soumisParAutreMembre: selectedForm.soumisParAutreMembre || {},
        delegueInfo: selectedForm.delegueInfo || {},
        achatsCarteCréditProfessionnelle: selectedForm.achatsCarteCréditProfessionnelle || "non",
        depensesEtrReclamer: selectedForm.depensesEtrReclamer || "non",
        depensesActiviteExterne: selectedForm.depensesActiviteExterne || "non",
        reclameBoissonAlcoolise: selectedForm.reclameBoissonAlcoolise || "non",
        etatDemande: selectedForm.etatDemande || "",
        funds: selectedForm.funds || "",
        centreCout: selectedForm.centreCout || "",
        ordre: selectedForm.ordre || null,
        traitant: selectedForm.traitant || [],
        montantkilometrage: selectedForm.montantkilometrage || 0,
        montantVisaConseil: selectedForm.montantVisaConseil || 0,
        montantAutresDepenses: selectedForm.montantAutresDepenses || 0,
        montantNet: selectedForm.montantNet || 0,
        listeDesNotes: selectedForm.listeDesNotes || [],

        depenses: selectedForm.depenses
          ? selectedForm.depenses.map((depense) => ({
            ...depense,
            rows: depense.rows?.map((row) => ({ ...row })) || [],
            files:
              depense.files?.map((file) => {
                const base64Data = `data:${file.contentType};base64,${file.data}`;
                return base64ToFile(
                  base64Data,
                  file.filename,
                  file.contentType,
                  file._id
                );
              }) || [],
            trajetFiles:
              depense.trajetFiles?.map((file) => {
                const base64Data = `data:${file.contentType};base64,${file.data}`;
                return base64ToFile(
                  base64Data,
                  file.filename,
                  file.contentType,
                  file._id
                );
              }) || [],
          }))
          : [],
        visaConseil: selectedForm.visaConseil
          ? {
            ...selectedForm.visaConseil,
            files:
              selectedForm.visaConseil.files?.map((file) => {
                const base64Data = `data:${file.contentType};base64,${file.data}`;
                return base64ToFile(
                  base64Data,
                  file.filename,
                  file.contentType,
                  file._id
                );
              }) || [],
          }
          : [],

        ETRFiles:
          selectedForm.ETRFiles?.map((file) => {
            const base64Data = `data:${file.contentType};base64,${file.data}`;
            return base64ToFile(base64Data, file.filename, file.contentType, file._id);
          }) || [],

        formation: selectedForm.formation
          ? {
            ...selectedForm.formation,
            dateFormation: selectedForm.formation.dateFormation?.slice(0, 10),
            files:
              selectedForm.formation.files?.map((file) => {
                const base64Data = `data:${file.contentType};base64,${file.data}`;
                return base64ToFile(
                  base64Data,
                  file.filename,
                  file.contentType,
                  file._id
                );
              }) || [],
          }
          : [],
      }));
    }
  }, [user, selectedForm, page]); // Add selectedForm to the dependency array

  //Chargement des natures de dépenses et montants max
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/NatureDepense`)
      .then((response) => response.json())
      .then((data) => {
        // setNatureDepenses(data);

        // fonction pour extraire le nombre
        const extractAmount = (value) => {
          const match = value.match(/(\d+)/);
          return match ? parseInt(match[1], 10) : null;
        };

        // Objet qui contiendra les montants maximums par nature
        const amounts = {};

        // Parcours des données reçues de l’API
        data.forEach((item) => {
          if (
            item.value.startsWith("Repas") ||
            item.value.startsWith("Hébergement")
          ) {
            const num = extractAmount(item.value);
            if (num !== null) {
              amounts[item.value] = num;
            }
          }
        });

        // on stocke directement dans le state
        setMaxAmounts(amounts);
      })
      .catch((error) =>
        console.error("Error fetching NatureDepense:", error)
      );
  }, []);

  //Déterminer si l’utilisateur peut traiter la demande
  function getTraite(selectedForm, user, checkGroupAdmin, checkGroupRecMensuelle) {

    // Sécurité : si formulaire ou utilisateur non chargés
    if (!selectedForm || !user) return false; // Ajout de cette ligne

    // Cas admin
    if (checkGroupAdmin) return true;

    // Cas traitant actuel
    if (selectedForm.traitant[selectedForm.traitant.length - 1]?.userId === user.id) {
      return true;
    }

    // Cas 3 : groupe RecMensuelle et demande approuvée par le gestionnaire
    if (checkGroupRecMensuelle && selectedForm.managerInfo?.etatDemande === "Approuvé") {
      return true;
    }

    return false;
  }

  // Résultat utilisé dans le composant
  const traite = getTraite(selectedForm, user, checkGroupAdmin, checkGroupRecMensuelle);

  //Gestion centralisée des changements de champs
  const handleChange = (e) => {
    const { name, value } = e.target;

    setErrors("");

    setFormData((prevData) => {
      if (name === "periodReclamation") {
        const selectedDate = new Date(value);
        const currentDate = new Date();

        // Calculer la différence en mois
        const monthDifference =
          (currentDate.getFullYear() - selectedDate.getFullYear()) * 12 +
          currentDate.getMonth() -
          selectedDate.getMonth();

        // Vérifier si la différence est inférieure à 3 mois
        if (monthDifference > 4) {
          setErrorMessage(
            "Votre reclamation de dépenses risque ne pas être remboursée car le délai de trois mois est outrepassé."
          );

          return {
            ...prevData,
            [name]: value,
            periodDepasseTroisMois: "oui",
            depenses: prevData.depenses.map((depense) => ({
              ...depense,
              dateDepense: "",
              rows: depense.rows.map((row) =>
                row.typeDepenses === "Kilométrage"
                  ? { ...row, kms: null, montant: null }
                  : row
              ),
            })),
          };
        } else {
          setErrorMessage(""); // Pas d'erreur si la condition n'est pas remplie
          return {
            ...prevData,
            [name]: value,
            periodDepasseTroisMois: "non",
            depenses: prevData.depenses.map((depense) => ({
              ...depense,
              dateDepense: "",
              rows: depense.rows.map((row) =>
                row.typeDepenses === "Kilométrage"
                  ? { ...row, kms: null, montant: null }
                  : row
              ),
            })),
          };
        }
      }
      if (name === "soumisAutreMembre" && value === "non") {
        return {
          ...prevData,
          soumisAutreMembre: "non",
          soumisParAutreMembre: {
          },
          commentaireRaisonSoumission: "",
        };
      }

      if (name === "verificationDelegue" && value === "non") {
        return {
          ...prevData,
          verificationDelegue: "non",
          delegueInfo: {
          },
        };
      }

      if (
        name === "managerInfo" ||
        name === "soumisParAutreMembre" ||
        name === "delegueInfo"
      ) {
        return {
          ...prevData,
          [name]: {
            ...value, // Mise à jour de l'objet correspondant
          },
        };
      }
      if (name === "achatsCarteCréditProfessionnelle" && value === "non") {
        return {
          ...prevData,
          achatsCarteCréditProfessionnelle: "non",
          visaConseil: {},
        };
      }
      if (name === "depensesEtrReclamer" && value === "non") {
        return {
          ...prevData,
          depensesEtrReclamer: "non",
          ETRFiles: [],
        };
      }
      if (
        name === "montantTotalReleveVisa" ||
        name === "montantTotalDepensesVisa"
      ) {
        return {
          ...prevData,
          visaConseil: {
            ...prevData.visaConseil,
            files: formData.visaConseil.files,
            [name]: value,
          },
        };
      }
      if (
        name === "dateFormation" ||
        name === "nomFormation" ||
        name === "commentaireFormation"
      ) {
        return {
          ...prevData,
          formation: {
            ...prevData.formation,
            [name]: value,
          },
        };
      }
      if (name === "depensesActiviteExterne" && value === "non") {
        return {
          ...prevData,
          depensesActiviteExterne: "non",
          formation: {},
        };
      }
      if (name === "periodReclamation") {
        //i want for each row in each depense if (row.typeDepenses===Kilométrage) {row.Kms=null and row.montant===null}
      }
      // Mise à jour des autres champs
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const validateFormEtape1 = () => {
    const newErrors = {};

    if (!formData.soumisAutreMembre.trim()) {
      newErrors.soumisAutreMembre = "Ce champ est requis.";
    }
    if (
      formData.soumisAutreMembre === "oui" &&
      !formData.soumisParAutreMembre.nom
    ) {
      newErrors.soumisParAutreMembre = "Ce champ est requis.";
    }
    if (
      formData.soumisAutreMembre === "oui" &&
      !formData.commentaireRaisonSoumission
    ) {
      newErrors.commentaireRaisonSoumission = "Ce champ est requis.";
    }
    if (!formData.posteOccupe) {
      newErrors.posteOccupe = "Ce champ est requis.";
    }
    if (!formData.LieuTravail) {
      newErrors.LieuTravail = "Ce champ est requis.";
    }
    if (!formData.managerInfo.nom) {
      newErrors.managerInfo = "Ce champ est requis.";
    }
    if (formData.verificationDelegue === "oui" && !formData.delegueInfo.nom) {
      newErrors.delegueInfo = "Ce champ est requis.";
    }
    if (!formData.periodReclamation) {
      newErrors.periodReclamation = "Ce champ est requis.";
    } else {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const maxMonth = `${year}-${month}`;

      const past = new Date();
      past.setMonth(past.getMonth() - 12);
      const minYear = past.getFullYear();
      const minMonth = String(past.getMonth() + 1).padStart(2, "0");
      const minMonthValue = `${minYear}-${minMonth}`;
      // 🔹 Vérification : entre min et max
      if (formData.periodReclamation < minMonthValue || formData.periodReclamation > maxMonth) {
        newErrors.periodReclamation = `La période doit être entre ${minMonthValue} et ${maxMonth}`;

      }
    }
    if (
      !formData.justificationOutrepasse &&
      formData.periodDepasseTroisMois === "oui"
    ) {
      newErrors.justificationOutrepasse = "Ce champ est requis.";
    }
    if (
      formData.reclameBoissonAlcoolise==="oui"
    ) {
      newErrors.reclameBoissonAlcoolise = "Aucune boisson alcoolisée ne peut être réclamée.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };


  const validateFormEtape2 = () => {
    const newErrors = {};

    if (!formData.depenses || formData.depenses.length === 0) {
      newErrors.depenses = "Veuillez ajouter au moins une depense.";
    }

    formData.depenses.forEach((depense) => {
      if (
        !depense.dateDepense ||
        isNaN(new Date(depense.dateDepense).getTime())
      ) {
        newErrors[`dateDepense_${depense.id}`] =
          "La date de dépense est requise et doit être valide.";
      }
      if (!depense.descriptionDepense) {
        newErrors[`descriptionDepense_${depense.id}`] =
          "La description est requise.";
      }
      // Validation de chaque ligne (row) dans chaque dépense
      depense.rows.forEach((row) => {
        if (row.typeDepenses === "Kilométrage" && !depense.deplacement) {
          newErrors[`deplacement_${depense.id}`] =
            "Inscrire le point de départ-destination-point de retour.";
        }
        // Validation du type de dépense
        if (!row.typeDepenses) {
          newErrors[`typeDepenses_${row.rowId}`] =
            "Le type de dépense est requis.";
        }
        if (
          row.typeDepenses === "Visa du Conseil" &&
          formData.achatsCarteCréditProfessionnelle === "non"
        ) {
          newErrors[`typeDepenses_${row.rowId}`] =
            "Veuillez sélectionner 'Oui' pour le visa de conseil sur la première page.";
        }
        // Validation des kilomètres
        if (row.typeDepenses === "Kilométrage" && row.kms <= 0 && page !== "Mes taches") {
          newErrors[`kms_${row.rowId}`] =
            "Le nombre de kilomètres doit être supérieur à 0.";
        }
        // Validation du fournisseur
        if (row.typeDepenses !== "Kilométrage" && !row.fournisseur) {
          newErrors[`fournisseur_${row.rowId}`] = "Le fournisseur est requis.";
        }
        // Validation de la nature de la dépense
        if (!row.natureDepenses) {
          newErrors[`natureDepenses_${row.rowId}`] =
            "La nature de la dépense est requise.";
        }

        if (
          row.natureDepenses === "407 ETR" &&
          formData.depensesEtrReclamer === "non"
        ) {
          newErrors[`natureDepenses_${row.rowId}`] =
            "Veuillez sélectionner 'Oui' pour 407 ETR sur la première page.";
        }

        if (
          !row.commentaire &&
          maxAmounts[row.natureDepenses] !== undefined &&
          row.montant > maxAmounts[row.natureDepenses]
        ) {
          newErrors[`commentaire_${row.rowId}`] =
            // "Veuillez ajouter une explication pour ce dépassement";

            "Le montant du repas réclamé dépasse l'indemnité maximale. S'il s'agit d'une dépense de Visa du Conseil, veuillez inscrire un commentaire pour justifier le dépassement et inscrire le montant du dépassement (à la colonne « Montant à rembourser au Conseil »). S'il s'agit d'un repas payé personnellement, veuillez inscrire un commentaire pour justifier le dépassement ou réduire le montant réclamé."
        }
        // Validation du compte
        if (row.compte <= 0) {
          newErrors[`compte_${row.rowId}`] = "Le numéro de compte est requis.";
        }
        // Validation funds
        if (!row.funds) {
          newErrors[`funds_${row.rowId}`] = "Le fonds est requis.";
        }
        // Validation centreCouts
        if (!row.centreCouts) {
          newErrors[`centreCouts_${row.rowId}`] =
            "Le centre de cout est requis.";
        }
        console.log()
        // Validation du montant
        if ((!row.montant || Number(row.montant) === 0) && !formData.etatDemande === "En traitement") {
          newErrors[`montant_${row.rowId}`] = "Le montant est requis.";
        }
        if (row.typeDepenses !== "Visa du Conseil" && Number(row.montant) < 0) {
          newErrors[`montant_${row.rowId}`] =
            "Le montant doit être supérieur à 0.";
        }

        // Validation du montant remboursé
        if (Number(row.montantRembourser) < 0) {
          newErrors[`montantRembourser_${row.rowId}`] = "Le montant à rembourser ne peut pas être négatif.";
        }
      });

      const allRowsAreKilometrageOrVisaConseilPerso = depense.rows.every((row) => {
        return (
          row.typeDepenses === "Kilométrage" ||
          row.natureDepenses === "Hébergement - famille/ami (25$)" || row.natureDepenses === "Dépense personnelle - Visa"
          || row.natureDepenses === "407 ETR"
          || depense.tousReçusFournis === "non"
        );
      });

      if ((!depense.files || depense.files.length === 0) && !allRowsAreKilometrageOrVisaConseilPerso) {
        newErrors[`files_${depense.id}`] = "Veuillez joindre une copie de vos factures.";
      }
      // const activationDate = new Date("2026-04-29");
      
      // if (new Date(formData.dateSoumission) >= activationDate &&(!depense.trajetFiles || depense.trajetFiles.length === 0) && depense.rows.some((row) => row.typeDepenses === "Kilométrage")) {
      //   newErrors[`trajetFiles_${depense.id}`] = "Veuillez joindre une capture du trajet .";
      // }

    });

    if (
      formData.achatsCarteCréditProfessionnelle === "oui" &&
      (!formData.visaConseil.montantTotalReleveVisa ||
        Number(formData.visaConseil.montantTotalReleveVisa) === 0)
    ) {
      newErrors.montantTotalReleveVisa = "Le montant est requis";
    }
    if (
      formData.achatsCarteCréditProfessionnelle === "oui" &&
      Number(formData.visaConseil.montantTotalReleveVisa) !==
      Number(formData.visaConseil.montantTotalDepensesVisa)
    ) {
      newErrors.montantTotalReleveVisa =
        "Le montant total du relevé Visa ne correspond pas au montant total des dépenses Visa.";
    }
    if (
      formData.achatsCarteCréditProfessionnelle === "oui" &&
      (!formData.visaConseil.files || formData.visaConseil.files.length === 0)
    ) {
      newErrors.Visafiles = "Veuillez joindre une copie de votre relevé";
    }
    if (
      formData.depensesEtrReclamer === "oui" &&
      (!formData.ETRFiles || formData.ETRFiles.length === 0)
    ) {
      newErrors.ETRfiles = "Veuillez joindre une copie de votre facture";
    }

    if (
      formData.depensesActiviteExterne === "oui" &&
      !formData.formation.dateFormation
    ) {
      newErrors.dateFormation = "La date est requise";
    }

    if (
      formData.depensesActiviteExterne === "oui" &&
      !formData.formation.nomFormation
    ) {
      newErrors.nomFormation = "Le nom est requis";
    }
    if (
      formData.depensesActiviteExterne === "oui" &&
      (!formData.formation.files || formData.formation.files.length === 0)
    ) {
      newErrors.Formationfiles =
        "Veuillez joindre une copie du formulaire approuvé de demande de participation.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };



  // Vérifie s'il y a des différences entre les dépenses / Visa
  // du formulaire en cours et celles déjà enregistrées (selectedForm)
  const areDepensesOrVisaDifferent = () => {

    // Dépenses actuelles du formulaire (sécurité si undefined)
    const formDepenses = formData.depenses || [];
    // Dépenses sauvegardées dans le formulaire sélectionné
    const selectedDepenses = selectedForm.depenses || [];

     // COMPARAISON DES DÉPENSES
    const depensesDifferent = (() => {

      // Si le nombre de dépenses est différent → il y a une modification
      if (formDepenses.length !== selectedDepenses.length) return true;

      // Vérifie chaque dépense une par une
      return !formDepenses.every((formItem, index) => {
        const selectedItem = selectedDepenses[index];
        // Comparaison des champs principaux de la dépense
        if (
          formItem.dateDepense !== selectedItem.dateDepense ||
          formItem.descriptionDepense !== selectedItem.descriptionDepense ||
          formItem.deplacement !== selectedItem.deplacement ||
          formItem.rows.length !== selectedItem.rows.length
        ) {
          return false;
        }

        // COMPARAISON DES LIGNES (ROWS)
        return formItem.rows.every((formRow, rowIndex) => {
          const selectedRow = selectedItem.rows[rowIndex];
          // Comparaison des kilomètres en string
          // (évite les différences null / "" / number)
          const sameKms = String(formRow.kms) === String(selectedRow.kms);

          // Comparaison complète de chaque champ de la ligne
          return (
            formRow.typeDepenses === selectedRow.typeDepenses &&
            sameKms &&
            formRow.fournisseur === selectedRow.fournisseur &&
            formRow.natureDepenses === selectedRow.natureDepenses &&
            formRow.compte === selectedRow.compte &&
            formRow.funds === selectedRow.funds &&
            formRow.centreCouts === selectedRow.centreCouts &&
            formRow.ordre === selectedRow.ordre &&
            formRow.montant === selectedRow.montant &&
            formRow.montantRembourser === selectedRow.montantRembourser &&
            formRow.commentaire === selectedRow.commentaire
          );
        });
      });
    })();

    // COMPARAISON DES DONNÉES VISA
    const visaDifferent =
      formData.visaConseil?.montantTotalReleveVisa !==
      selectedForm.visaConseil?.montantTotalReleveVisa ||
      formData.visaConseil?.montantTotalDepensesVisa !==
      selectedForm.visaConseil?.montantTotalDepensesVisa;

    // Retourne true si une différence existe
    return depensesDifferent || visaDifferent;
  };

  const validateFormEtape3 = (actionType) => {
    const newErrors = {};

    // Le commentaire est requis si :
    // 1️⃣ Les dépenses ou Visa ont été modifiés
    // 2️⃣ OU action Rejetée / Réassignée depuis "Mes taches"
    // 3️⃣ OU approbation après un "Enregistrer"
    // ET si aucune nouvelle note n’a été ajoutée
    if (
      (areDepensesOrVisaDifferent() ||
        (page === "Mes taches" && (actionType === "Rejeté" || actionType === "Réassignée")) ||
        (
          page === "Mes taches" &&
          actionType === "Approuvé" &&
          formData.traitant?.length >= 2 &&
          formData.traitant[formData.traitant.length - 2]?.etatDemande === "Enregistrer"
        )
      ) && formData.listeDesNotes.length === selectedForm.listeDesNotes.length
    ) {
      newErrors.commentaireTable = "Ce champ est requis.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  const renderError = (field) => {
    return errors[field] ? (
      <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
          !
        </span>
        {errors[field]}
      </p>
    ) : null;
  };


  

  // ======================================================
  // GESTION DES ACTIONS SUR LE FORMULAIRE
  // (Soumettre, Approuver, Rejeter, Réassigner, Sauvegarder)
  // ======================================================
  const handleFormAction = async (e, actionType, next = false) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Objet temporaire pour mettre à jour l’état
    let etatInfoUpdate = {};

    // CAS : APPROUVÉ
    if (actionType === "Approuvé") {
      if (formData.soumisParAutreMembre && Object.keys(formData.soumisParAutreMembre).length > 0 && formData.soumisParAutreMembre.etatDemande !== "Approuvé") {
        etatInfoUpdate.soumisParAutreMembre = {
          ...formData.soumisParAutreMembre,
          etatDemande: "Approuvé",
        };
        if (formData.delegueInfo && Object.keys(formData.delegueInfo).length > 0 && formData.soumisParAutreMembre.userId === formData.delegueInfo?.userId) {
          etatInfoUpdate.delegueInfo = {
            ...formData.delegueInfo,
            etatDemande: "Approuvé",
          };
        }
      }
      else if (formData.delegueInfo && Object.keys(formData.delegueInfo).length > 0 && formData.delegueInfo.etatDemande !== "Approuvé") {
        etatInfoUpdate.delegueInfo = {
          ...formData.delegueInfo,
          etatDemande: "Approuvé",
        };
      } else {
        etatInfoUpdate.managerInfo = {
          ...formData.managerInfo,
          etatDemande: "Approuvé",
        };
      }
    }

    // CAS : RÉASSIGNÉE
    if (actionType === "Réassignée") {
      if (formData.delegueInfo && formData.delegueInfo.etatDemande !== "Approuvé" && formData.managerInfo?.userId === idUser) {
        etatInfoUpdate.delegueInfo = {
          ...formData.delegueInfo,
          etatDemande: "Approuvé",
        };
      }
    }

    // CAS : REJETÉ
    if (actionType === "Rejeté") {
      if (formData.soumisAutreMembre === "oui" && formData.soumisParAutreMembre && Object.keys(formData.soumisParAutreMembre).length > 0 && formData.soumisParAutreMembre.etatDemande === "") {
        etatInfoUpdate.soumisParAutreMembre = {
          ...formData.soumisParAutreMembre,
          etatDemande: "Rejeté",
        };
      }
      else if (formData.verificationDelegue === "oui" && formData.delegueInfo && Object.keys(formData.delegueInfo).length > 0 && formData.delegueInfo.etatDemande === "") {
        etatInfoUpdate.delegueInfo = {
          ...formData.delegueInfo,
          etatDemande: "Rejeté",
        };
      } else if (formData.managerInfo.etatDemande === "") {
        etatInfoUpdate.managerInfo = {
          ...formData.managerInfo,
          etatDemande: "Rejeté",
        };
      }
    }

    // CAS : EN TRAITEMENT
    // (remise à zéro des états)
    if (actionType === "En traitement") {
      if (formData.soumisAutreMembre === "oui") {
        etatInfoUpdate.soumisParAutreMembre = {
          ...formData.soumisParAutreMembre,
          etatDemande: "",
        };
      }

      if (formData.verificationDelegue === "oui") {
        etatInfoUpdate.delegueInfo = {
          ...formData.delegueInfo,
          etatDemande: "",
        };
      }

      etatInfoUpdate.managerInfo = {
        ...formData.managerInfo,
        etatDemande: "",
      };
    }


    // GESTION DE L’HISTORIQUE DES TRAITANTS
    let updatedTraitant = [];

    // ---------- EN TRAITEMENT ----------
    if (actionType === "En traitement") {
      let nouveauTraitant;

      // Si soumis par un autre membre → c’est lui le prochain traitant
      if (formData.soumisParAutreMembre?.nom) {
        nouveauTraitant = {
          userId: formData.soumisParAutreMembre.userId,
          nom: formData.soumisParAutreMembre.nom,
          email: formData.soumisParAutreMembre.email,
          etatDemande: "En traitement",
          dateHeure: currentDate,
        };
      } else { // Sinon → délégué ou gestionnaire
        nouveauTraitant = {
          userId: formData.delegueInfo?.userId || formData.managerInfo?.userId,
          nom: formData.delegueInfo?.nom || formData.managerInfo?.nom,
          email: formData.delegueInfo?.email || formData.managerInfo?.email,
          etatDemande: "En traitement",
          dateHeure: currentDate,
        };
      }

      updatedTraitant = [...(formData.traitant || []), nouveauTraitant];

    } 
    // ---------- APPROUVÉ ----------
    else if (actionType === "Approuvé") {
      updatedTraitant = [...(formData.traitant || [])];

      // Étape 1 : Ajouter l'utilisateur actuel comme "Approuvée"
      updatedTraitant.push({
        userId: user.id,
        nom: user.displayName,
        email: user.mail,
        etatDemande: "Approuvé",
        dateHeure: currentDate,
      });

      // Étape 2 : Ajouter le prochain traitant (en traitement)
      if (
        formData.soumisParAutreMembre && Object.keys(formData.soumisParAutreMembre).length > 0 && formData.soumisParAutreMembre.etatDemande !== "Approuvé"
      ) {
        if (formData.delegueInfo && Object.keys(formData.delegueInfo).length > 0 && formData.soumisParAutreMembre.userId === formData.delegueInfo?.userId) {
          updatedTraitant.push({
            userId: formData.managerInfo?.userId,
            nom: formData.managerInfo?.nom,
            email: formData.managerInfo?.email,
            etatDemande: "En traitement",
            dateHeure: currentDate,
          });
        } else {
          updatedTraitant.push({
            userId: formData.delegueInfo?.userId || formData.managerInfo?.userId,
            nom: formData.delegueInfo?.nom || formData.managerInfo?.nom,
            email: formData.delegueInfo?.email || formData.managerInfo?.email,
            etatDemande: "En traitement",
            dateHeure: currentDate,
          });
        }
      } else if (
        formData.delegueInfo && Object.keys(formData.delegueInfo).length > 0 && formData.delegueInfo.etatDemande !== "Approuvé"
      ) {

        updatedTraitant.push({
          userId: formData.managerInfo?.userId,
          nom: formData.managerInfo?.nom,
          email: formData.managerInfo?.email,
          etatDemande: "En traitement",
          dateHeure: currentDate,
        });
      } else if (
        formData.managerInfo?.etatDemande !== "Approuvé" ||
        (
          formData.managerInfo?.etatDemande === "Approuvé" &&
          !checkGroupAdmin &&
          !checkGroupRecMensuelle
        )
      ) {
        updatedTraitant.push({
          userId: "3ef1d205-d86b-4fda-b16d-17d0bdf970e9",
          nom: "Ryan, Melanie",
          email: "ryanm@CSViamonde.ca",
          etatDemande: "En traitement",
          dateHeure: currentDate,
        });
      }
    } 
    // ---------- RÉASSIGNÉE ----------
    else if (actionType === "Réassignée") {
      updatedTraitant = [
        ...(formData.traitant || []),
        {
          userId: user.id,
          nom: user.displayName,
          email: user.mail,
          etatDemande: "Réassignée",
          dateHeure: currentDate,
        },
        {
          userId: idUser,
          nom: nomUser,
          email: emailUser,
          etatDemande: "En traitement",
          dateHeure: currentDate,
        },
      ];
    } 
    // ---------- REJETÉ ----------
    else if (actionType === "Rejeté") {
      updatedTraitant = [
        ...(formData.traitant || []),
        {
          userId: user.id,
          nom: user.displayName,
          email: user.mail,
          etatDemande: "Rejeté",
          dateHeure: currentDate,
        }
      ];
    } 
    // ---------- SAUVEGARDER ----------
    else if (actionType === "Sauvegarder") {
      updatedTraitant = [
        ...(formData.traitant || []),
        {
          userId: user.id,
          nom: user.displayName,
          email: user.mail,
          etatDemande: "Enregistrer",
          dateHeure: currentDate,
        },
        {
          userId: user.id,
          nom: user.displayName,
          email: user.mail,
          etatDemande: "En traitement",
          dateHeure: currentDate,
        },
      ];

    } else {
      updatedTraitant = formData.traitant || [];
    }

    // ======================================================
    // CONSTRUCTION DU FORMULAIRE FINAL À ENVOYER
    // ======================================================
    const updatedFormData = {
      ...formData,// Données existantes du formulaire
      ...etatInfoUpdate,// Mises à jour des états (manager / délégué / soumis par autre membre)
      etatDemande: // Détermination de l'état global du formulaire
        actionType === "En traitement" ||
          actionType === "Brouillon" ||
          actionType === "Rejeté" ||
          (actionType === "Approuvé" && formData.managerInfo?.etatDemande === "Approuvé" && (checkGroupRecMensuelle || checkGroupAdmin))
          ? actionType
          : formData.etatDemande,
      dateSoumission:
        page === "Mes taches" ? formData.dateSoumission : currentDate.toISOString(),

      // Toute nouvelle note devient "ancienne" après soumission
      // sauf en mode Brouillon
      listeDesNotes:
        formData.listeDesNotes?.map((note) =>
          actionType !== "Brouillon"
            ? note.ancien
              ? note
              : { ...note, ancien: true }
            : note
        ) || [],
      traitant: updatedTraitant
    };


    // ===============================
    // DÉTERMINATION DE LA MÉTHODE HTTP
    // ===============================
    // PUT : mise à jour d'un formulaire existant
    // POST : création d'un nouveau formulaire
    const method = formId ? "PUT" : "POST";
    const formType = "ReclamationDepense"; // Type de formulaire envoyé au backend
    const url = formId // URL de l'API selon création ou modification
      ? `${process.env.REACT_APP_API_BASE_URL}/formReclamationDepense/${formId}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/formReclamationDepense?form=${formType}`; // Use POST for creating a new form


    // ===============================
    // PRÉPARATION DU FormData
    // ===============================
    const formDataToSend = new FormData(); // Ajout des données principales du formulaire (JSON)
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));

    // 🔹 Dépenses
    formData.depenses.forEach((depense, depenseIndex) => {
      depense.files.forEach((file, fileIndex) => {
        if (file._id) {
          formDataToSend.append(
            `depenses[${depenseIndex}][files][${fileIndex}][_id]`,
            file._id
          );
        } else {
          const blob = new Blob([file], { type: file.type });
          formDataToSend.append(
            `depenses[${depenseIndex}][files][${fileIndex}]`,
            blob,
            file.name
          );
        }
      });
      depense.trajetFiles.forEach((file, fileIndex) => {
        if (file._id) {
          formDataToSend.append(
            `depenses[${depenseIndex}][trajetFiles][${fileIndex}][_id]`,
            file._id
          );
        } else {
          const blob = new Blob([file], { type: file.type });
          formDataToSend.append(
            `depenses[${depenseIndex}][trajetFiles][${fileIndex}]`,
            blob,
            file.name
          );
        }
      });
    });

    // 🔹 Visa Conseil
    if (formData.visaConseil?.files?.length > 0) {
      formData.visaConseil.files.forEach((file, fileIndex) => {
        if (file._id) {
          formDataToSend.append(
            `visaConseil[files][${fileIndex}][_id]`,
            file._id
          );
        } else {
          const blob = new Blob([file], { type: file.type });
          formDataToSend.append(
            `visaConseil[files][${fileIndex}]`,
            blob,
            file.name
          );
        }
      });
    }

    // 🔹 ETRFiles
    if (formData.ETRFiles?.length > 0) {
      formData.ETRFiles.forEach((file, fileIndex) => {
        if (file._id) {
          formDataToSend.append(`ETRFiles[${fileIndex}][_id]`, file._id);
        } else {
          const blob = new Blob([file], { type: file.type });
          formDataToSend.append(`ETRFiles[${fileIndex}]`, blob, file.name);
        }
      });
    }

    // 🔹 Formation
    if (formData.formation?.files?.length > 0) {
      formData.formation.files.forEach((file, fileIndex) => {
        if (file._id) {
          formDataToSend.append(
            `formation[files][${fileIndex}][_id]`,
            file._id
          );
        } else {
          const blob = new Blob([file], { type: file.type });
          formDataToSend.append(
            `formation[files][${fileIndex}]`,
            blob,
            file.name
          );
        }
      });
    }

    // Send the form data to the backend
    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });

      if (response.ok) {

        const data = await response.json();

        // Store the ID if this was a new form
        if (!formId && data.newForm?._id) {
          setFormId(data.newForm._id);
        }

        const newMontantKilometrage = updatedFormData.depenses
          .flatMap((depense) => depense.rows)
          .filter((row) => row.typeDepenses === "Kilométrage")
          .reduce((total, row) => total + (Number(row.montant) || 0), 0);

        const newMontantVisaConseil = updatedFormData.depenses
          .flatMap((depense) => depense.rows)
          .filter((row) => row.typeDepenses === "Visa du Conseil")
          .reduce((total, row) => total + (Number(row.montant) || 0), 0);

        const newMontantAutresDepenses = updatedFormData.depenses
          .flatMap((depense) => depense.rows)
          .filter((row) => row.typeDepenses === "Autre dépense")
          .reduce((total, row) => total + (Number(row.montant) || 0), 0);

        const newMontantRembourserConseil = updatedFormData.depenses
          .flatMap((depense) => depense.rows)
          .filter((row) => row.typeDepenses === "Visa du Conseil")
          .reduce((total, row) => total + (Number(row.montantRembourser) || 0), 0);


        const newMontantNet = newMontantKilometrage + newMontantAutresDepenses - newMontantRembourserConseil;

        setFormData({
          ...updatedFormData,
          montantkilometrage: parseFloat(newMontantKilometrage.toFixed(2)),
          montantVisaConseil: parseFloat(newMontantVisaConseil.toFixed(2)),
          montantAutresDepenses: parseFloat(newMontantAutresDepenses.toFixed(2)),
          montantRembourserConseil: parseFloat(newMontantRembourserConseil.toFixed(2)),
          montantNet: parseFloat(newMontantNet.toFixed(2)),
        });
        

        if (next === false) {
          setIsSubmitted(true); // Show popup
          // Hide popup after 3 seconds
          await new Promise((resolve) => {
            setTimeout(() => {
              setIsSubmitted(false); // Hide the popup after timeout
              resolve(); // Resolve the promise after 3 seconds
            }, 2000);
          });
        } else {
          if (formData.etatDemande !== "Brouillon") {
            setIsSubmitted(true); // Show popup
            // Hide popup after 3 seconds
            await new Promise((resolve) => {
              setTimeout(() => {
                setIsSubmitted(false); // Hide the popup after timeout
                resolve(); // Resolve the promise after 3 seconds
              }, 2000);
            });
          }
        }
        if (updatedFormData.etatDemande !== "Brouillon") {
          if (socket) {
            socket.emit("requestUpdated");
          }
        }

        if (updatedFormData.etatDemande !== "Brouillon" && updatedFormData.etatDemande !== "" && actionType !== "Sauvegarder") {
          if (page === "Mes taches") {
            window.close()
          } else {
            navigate("/demande", { state: { selectedForm: null } });
          }
        }


        // navigate("/demande", { state: { selectedForm: null } });

        // console.log(`Form data ${actionType.toLowerCase()} successfully!`);
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    }
  };

  const handleSave = (e, next = false) => {
    handleFormAction(e, "Brouillon", next); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis."
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const handleSubmit = (e) => {
    if (loadingAction) return;
    setLoadingAction("submit");
    handleFormAction(e, "En traitement"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
    setErrors("");
    setTimeout(() => setLoadingAction(null), 1000); // optionnel
  };

  const handleApprouve = (e) => {
    if (!validateFormEtape3("Approuvé")) return;
    handleFormAction(e, "Approuvé"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été Approuvé.");
    setcouleur("text-green-600");
    setErrors("");
  };
  const handleSaveSuper = (e) => {
    // if (!validateFormEtape3("Approuvé")) return;
    handleFormAction(e, "Sauvegarder"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été Enregistrée.");
    setcouleur("text-grey-600");
    setErrors("");
  };
  const handleRejeter = (e) => {
    if (!validateFormEtape3("Rejeté")) return;
    handleFormAction(e, "Rejeté"); // Use "Enregistrer" for save action
    setMessage("Le formulaire a été Rejeté.");
    setcouleur("text-red-700");
    setErrors("");
  };
  const handleReassign = (e) => {

    if (nomUser === "") {
      setErrorReassign("ce champs est requis")
    } else if (nomUser === selectedForm.nom) {
      setErrorReassign("La demande ne peut pas être réassignée à son auteur.")
    } else {
      setShowReassignPopup(false);
      handleFormAction(e, "Réassignée"); // Use "Enregistrer" for save action
      setMessage(`Succès ! Le formulaire a été Réassignée a ${nomUser}`);
      setcouleur("text-green-600");
      setErrors("");
    }
  };

  const handleUserSelect = (user) => {
    setErrorReassign("")
    setNomUser(user.displayName);
    setEmailUser(user.mail);
    setIdUser(user.id);

  };

  const handleReassignClick = () => {
    if (!validateFormEtape3("Réassignée")) return;
    setShowReassignPopup(true);
  };
  const handleReassignCancel = () => {
    setShowReassignPopup(false);
    setNomUser("");
    setEmailUser("");
    setIdUser("");
    setErrorReassign("")
  };

  const renderStep = () => {
    switch (currentStepComponent) {
      case "Etape1":
        return (
          <Etape1
            renderError={renderError}
            user={user}
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            errorMessage={errorMessage}
            isReadOnly={isReadOnly}
            page={page}
          />
        );
      case "Etape2":
        return (
          <Etape2
            renderError={renderError}
            user={user}
            formData={formData}
            handleChange={handleChange}
            setFormData={setFormData}
            isReadOnly={isReadOnly}
            page={page}
          />
        );
      case "Etape3":
        return (
          <Etape3
            formData={formData}
            handleChange={handleChange}
            setFormData={setFormData}
            user={user}
            isReadOnly={isReadOnly}
            page={page}
            renderError={renderError}
          />
        );
      default:
        return (
          <Etape1
            renderError={renderError}
            user={user}
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            errorMessage={errorMessage}
            isReadOnly={isReadOnly}
          />
        );
    }
  };

  const nextStep = () => {
    // Dynamically set the next step based on user choice
    if (currentStepComponent === "Etape1") {
      if (!validateFormEtape1()) {
        return;
      } else {
        setCurrentStepComponent("Etape2");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else if (currentStepComponent === "Etape2") {
      if (!validateFormEtape2()) {
        return;
      } else {
        setCurrentStepComponent("Etape3");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const previousStep = () => {
    if (currentStepComponent === "Etape3") {
      setCurrentStepComponent("Etape2");
    } else if (currentStepComponent === "Etape2") {
      setCurrentStepComponent("Etape1");
    }
  };

  const nextStepdesign = (Etape) => {

    // Vérification de validation uniquement à l'étape 1
    if (currentStepComponent === "Etape1" && !validateFormEtape1()) {
      return;
    } else if (
      currentStepComponent === "Etape2" &&
      !validateFormEtape2() &&
      Etape === "Etape3"
    ) {
      return;
    } else if (
      currentStepComponent === "Etape1" &&
      !validateFormEtape2() &&
      Etape === "Etape3"
    ) {
      return;
    }

    // Mise à jour de l'étape actuelle
    setCurrentStepComponent(Etape);
  };


  if (
    (!enabled && !selectedForm && page !== "Mes taches") ||
    (!enabled && selectedForm && selectedForm.etatDemande === "Brouillon" && page !== "Mes taches")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire Achat équipement informatique fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Le formulaire est désormais fermé.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-2 bg-gray-100 rounded-lg shadow-lg">
      <div className="mt-8 flex gap-4 p-4">
        <button
          onClick={(e) => {
            if (formData.etatDemande === "" || formData.etatDemande === "Brouillon") {
              handleSave(e, true);
            }
            nextStepdesign("Etape1")
          }}
          className={`px-4 py-2  text-white rounded-lg hover:bg-blue-500 transition 
        ${currentStepComponent === "Etape1" ? "bg-blue-500" : "bg-green-500"} `}
        >
          Étape 1{" "}
          {currentStepComponent !== "Etape1" && (
            <Check size={18} className="ml-2 inline" />
          )}
        </button>
        <button

          onClick={(e) => {
            if (formData.etatDemande === "" || formData.etatDemande === "Brouillon") {
              handleSave(e, true);
            }
            nextStepdesign("Etape2")
          }}
          className={`px-4 py-2 text-white rounded-lg hover:bg-blue-500 transition ${currentStepComponent === "Etape3"
              ? "bg-green-500"
              : currentStepComponent === "Etape2"
                ? "bg-blue-500"
                : "bg-blue-200"
            }`}
        >
          Étape 2{" "}
          {currentStepComponent === "Etape3" && (
            <Check size={18} className="ml-2 inline" />
          )}
        </button>
        <button
          onClick={() => nextStepdesign("Etape3")}
          className={`px-4 py-2  text-white rounded-lg hover:bg-blue-500 transition 
        ${currentStepComponent === "Etape3" ? "bg-blue-500" : "bg-blue-200"}`}
        >
          Étape 3
        </button>
      </div>

      {/* <div>
      {currentStepComponent !== 'Etape1' && <button onClick={previousStep}>Précédent</button>}
      {currentStepComponent !== 'Etape3' && <button onClick={nextStep}>Suivant</button>}
      {currentStepComponent === 'Etape3' && <button onClick={handleSubmit}>Soumettre</button>}
    </div> */}
      {renderStep()}

      <div className="flex justify-start mt-10 p-4 mb-4">
        <div className="flex space-x-4">
          {currentStepComponent !== "Etape1" && (
            <button
              type="button"
              className="mt-5 w-24 py-2 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold rounded-lg shadow-md transition-all duration-200 active:animate-ping"
              onClick={previousStep}
            >
              &lt; Précédent
            </button>
          )}
          {(formData.etatDemande === "Brouillon" ||
            formData.etatDemande === "") && (
              <button
                type="button"
                className="mt-5 w-24 py-2 bg-gray-600 hover:bg-gray-400 text-white font-semibold rounded-lg shadow-md transition-all duration-200"
                onClick={(e) => handleSave(e, false)}
              >
                Enregistrer
              </button>
            )}

          {currentStepComponent !== "Etape3" && (
            <button
              type="button"
              className="mt-5 w-24 py-2 bg-green-600 hover:bg-green-400 text-white font-semibold rounded-lg shadow-md transition-all duration-200 active:brightness-150 active:scale-95"
              onClick={(e) => {
                if (formData.etatDemande === "" || formData.etatDemande === "Brouillon") {
                  handleSave(e, true);
                }
                nextStep();
              }}
            >
              Suivant &gt;
            </button>
          )}
          {currentStepComponent === "Etape3" &&
            (formData.etatDemande === "Brouillon" ||
              formData.etatDemande === "" || (formData.etatDemande === "Rejeté" && page !== "Mes taches")) && (
              <button
                type="button"
                disabled={loadingAction !== null}
                // className="mt-5 w-24 py-2 bg-green-600 text-white rounded-md hover:bg-green-400"
                className={`
                    mt-5 w-24 py-2 rounded-md font-semibold
                    ${
                      loadingAction
                        ? "bg-green-300 text-white cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-500 active:scale-95"
                    }
                `}
                onClick={handleSubmit}
              >
                {loadingAction === "submit" && (
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                Soumettre
              </button>
            )}
          {(currentStepComponent === "Etape3" || currentStepComponent === "Etape2") && page === "Mes taches" && (selectedForm.etatDemande !== "Rejeté" && selectedForm.etatDemande !== "Approuvé") && traite && (
            <button
              type="button"
              className="mt-5 w-24 py-2 bg-gray-600 hover:bg-gray-400 text-white font-semibold rounded-lg shadow-md transition-all duration-200"

              onClick={handleSaveSuper}
            >
              Enregistrer
            </button>
          )}
          {currentStepComponent === "Etape3" && page === "Mes taches" && (selectedForm.etatDemande !== "Rejeté" && selectedForm.etatDemande !== "Approuvé") && traite &&
            (
              // Afficher si soumisParAutreMembre n'existe pas
              !selectedForm.soumisParAutreMembre ||

              // OU : nom vide ET etatDemande vide
              (selectedForm.soumisParAutreMembre.nom === "" &&
                selectedForm.soumisParAutreMembre.etatDemande === "") ||

              // OU : nom présent ET etatDemande approuvé
              (selectedForm.soumisParAutreMembre.nom !== "" &&
                selectedForm.soumisParAutreMembre.etatDemande === "Approuvé")
            ) && (
              <button
                type="button"
                className="ml-50 mt-5 w-24 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-400"
                onClick={handleReassignClick}
              >
                Réassigner
              </button>
            )}
          {currentStepComponent === "Etape3" && page === "Mes taches" && (selectedForm.etatDemande !== "Rejeté" && selectedForm.etatDemande !== "Approuvé") && traite && (
            <button
              type="button"
              className="mt-5 w-24 py-2 bg-red-600 text-white rounded-md hover:bg-red-400"
              onClick={handleRejeter}
            >
              Rejeter
            </button>
          )}
          {currentStepComponent === "Etape3" && page === "Mes taches" && (selectedForm.etatDemande !== "Rejeté" && selectedForm.etatDemande !== "Approuvé") && traite && (
            <button
              type="button"
              className="mt-5 w-24 py-2 bg-green-600 text-white rounded-md hover:bg-green-400"

              onClick={handleApprouve}
            >
              Approuver
            </button>
          )}
        </div>
      </div>
      {/* {showConfirm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-8 rounded-lg shadow-lg w-1/3">
                <h2 className="text-2xl font-bold mb-6 text-gray-800">
                  Approuvée la demande
                </h2>
                <div className="flex justify-end mt-6 space-x-4">
                  <button
                    className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                    onClick={() => setshowConfirm(false)}
                  >
                    Annuler
                  </button>
                  <button
                    className="px-5 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                    onClick={() => {
                      handleApprouve();
                      setshowConfirm(false);
                    }}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          )} */}



      {/* {showReassignPopup && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">

          <div className="bg-white w-[420px] max-w-[90%] p-8 rounded-2xl shadow-2xl animate-fadeIn">
            <h2 className="text-xl font-semibold text-gray-900 mb-5 border-b pb-3">
              Réassigner la tâche
            </h2>
            <label className="block mb-2 text-sm font-medium text-gray-600">
              Email:
            </label>
            <UsersList onUserSelect={handleUserSelect}></UsersList>
            {errorReassign && (
              <p className="text-red-500 text-sm mb-4">
                {errorReassign}
              </p>
            )}
            <label className="block mt-4 mb-2 text-sm font-medium text-gray-600">
              Nom:
            </label>
            <input
              type="text"
              value={nomUser}
              disabled
              className="w-1/2 p-3 border border-gray-300 rounded-lg text-gray-700 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400"
              required
            />
            <div className="flex justify-end mt-6 space-x-4">
              <button
                className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                onClick={handleReassignCancel}
              >
                Annuler
              </button>
              <button
                className="px-5 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                onClick={handleReassign}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )} */}
      {showReassignPopup && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-8 rounded-lg shadow-lg w-1/3">
                  <h2 className="text-2xl font-bold mb-6 text-gray-800">
                    Réassigner la tâche
                  </h2>
                  <label className="block mb-2 text-sm font-medium text-gray-600">
                    Nom:
                  </label>
                  {!nomUser && (<UsersList onUserSelect={handleUserSelect}></UsersList>)}
                  {errorReassign && (
                    <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
              <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
                !
              </span>
              {errorReassign}
            </p>
                  )}
                  {nomUser && (
                        <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                          {/* Avatar */}
                          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                            {nomUser.charAt(0).toUpperCase()}
                          </div>
      
                          {/* Infos */}
                          <div className="flex flex-col">
                            <span className="text-sm font-semibold text-gray-900">
                              {nomUser}
                            </span>
                            <span className="text-sm text-gray-700">
                              {emailUser}
                            </span>
                          </div>
      
                          {/* Bouton supprimer */}
                          
                            <button
                              onClick={() => {
                                setNomUser("");
                                setEmailUser("");
                                setIdUser("");
                                // setMatricule("");
                                setErrorReassign("");
                              }}
                              className="ml-auto text-red-400 hover:text-red-500 transition"
                            >
                              ✕
                            </button>
                        </div>
                      )}
                  <div className="flex justify-end mt-6 space-x-4">
                    <button
                      className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                      onClick={handleReassignCancel}
                    >
                      Annuler
                    </button>
                    <button
                      className="px-5 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                      onClick={handleReassign}
                    >
                      Confirmer
                    </button>
                  </div>
                </div>
              </div>
            )}
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <p className="ml-3 text-gray-700 font-medium">
            Chargement en cours...
          </p>
        </div>
      )}
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}

     {showDraftPopup && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl w-[560px] shadow-xl border border-gray-100 overflow-hidden">

      {/* HEADER */}
      <div className="px-7 pt-7 pb-5">
        <div className="flex items-center gap-2.5 mb-1.5">
          <div className="w-[34px] h-[34px] rounded-xl bg-gray-50 border border-gray-200 flex items-center justify-center shrink-0">
            <FileText size={16} className="text-gray-500" />
          </div>
          <h2 className="text-base font-medium text-gray-900">
            Brouillons en cours
          </h2>
        </div>
        <p className="text-[13px] text-gray-400 ml-[42px] leading-relaxed">
          Reprends une demande ou supprime-la si elle n'est plus nécessaire.
        </p>
      </div>

      <div className="h-px bg-gray-100 mx-7" />

      {/* LISTE */}
      <div className="px-7 py-4 flex flex-col gap-2 max-h-[300px] overflow-y-auto">
        {drafts.map((d) => {
          let formattedDate = "";
          if (d.periodReclamation) {
            const date = new Date(d.periodReclamation);
            formattedDate = date.toLocaleDateString("fr-FR", {
              month: "long",
              year: "numeric",
              timeZone: "UTC",
            });
            formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
          }

          return (
            <div
              key={d._id}
              className="flex items-center justify-between px-3.5 py-3 rounded-xl border border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50/60 transition-all cursor-pointer group"
              onClick={() => {
                setIsLoading(true);
                setShowDraftPopup(false);
                navigate(`/formulaire?numeroFormulaire=${d.numeroFormulaire}&page=Mes%20demandes`);
              }}
            >
              {/* LEFT */}
              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-2">
                  <span className="text-[13px] font-medium text-gray-900">
                    {d.numeroFormulaire}
                  </span>
                  <span className="text-[11px] bg-gray-100 text-gray-500 border border-gray-200 px-2 py-0.5 rounded-full tracking-tight">
                    Brouillon
                  </span>
                </div>

                {formattedDate && (
                  <span className="text-[12px] font-medium text-blue-600 bg-blue-50 border border-blue-200 px-2 py-0.5 rounded-md w-fit">
                    {formattedDate}
                  </span>
                )}
              </div>

              {/* DELETE */}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteDraft(d._id);
                }}
                className="p-1.5 px-2.5 rounded-lg border border-transparent text-gray-400 hover:text-red-500 hover:bg-red-50 hover:border-red-200 transition-all  group-hover:opacity-100"
              >
                <Trash2 size={15} />
              </button>
            </div>
          );
        })}
      </div>

      <div className="h-px bg-gray-100 mx-7" />

      {/* FOOTER */}
      <div className="px-7 py-5 flex justify-end gap-2">
        <button
          onClick={() => setShowDraftPopup(false)}
          className="text-[13px] px-4 py-2 rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 transition"
        >
          Annuler
        </button>
        <button
          onClick={() => setShowDraftPopup(false)}
          className="text-[13px] px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition"
        >
          Nouvelle demande
        </button>
      </div>

    </div>
  </div>
)}

      {showAccessDenied && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
    
    <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl p-8 w-[380px] text-center border border-white/30 animate-fadeIn">

      {/* Icon */}
      <div className="flex justify-center mb-5">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100 shadow-inner">
          <span className="text-3xl">⛔</span>
        </div>
      </div>

      {/* Title */}
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Accès refusé
      </h2>

      {/* Message principal */}
      <p className="text-gray-700 mb-2">
        Vous n'êtes pas autorisé à consulter ce formulaire.
      </p>

      {/* Sous message */}
      <p className="text-sm text-gray-500 mb-6">
        Redirection vers la page des réclamations de dépenses...
      </p>

      {/* Loader */}
      <div className="flex justify-center mb-6">
        <div className="w-6 h-6 border-4 border-gray-200 border-t-red-500 rounded-full animate-spin"></div>
      </div>

      {/* Button */}
      <button
        onClick={() => {
          navigate("/formulaire");
          setShowAccessDenied(false);
        }}
        className="px-5 py-2.5 bg-red-600 text-white rounded-xl hover:bg-red-500 transition-all duration-200 shadow-md hover:shadow-lg"
      >
        Retour
      </button>

    </div>
  </div>
)}
    </div>
  );
}

export default Formulaire;
